import PropTypes from "prop-types";
import styles from "./InputField.module.css";
import Field from "./Field";

export default function InputField({
  disabled,
  errorList = [],
  id,
  labelAlignment,
  labelText,
  name,
  placeholder,
  required = true,
  type,
  tabIndex,
  autoComplete,
}) {
  return (
    <Field
      id={id}
      labelText={labelText}
      errorList={errorList}
      labelAlignment={labelAlignment}
    >
      <input
        placeholder={placeholder}
        required={required}
        type={type}
        id={id}
        name={name}
        className={styles.InputField}
        disabled={disabled}
        tabIndex={tabIndex}
        autoComplete={autoComplete}
      />
    </Field>
  );
}

InputField.defaultProps = {
  tabIndex: 0,
};

InputField.propTypes = {
  disabled: PropTypes.bool,
  errorList: PropTypes.arrayOf(PropTypes.string),
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  type: PropTypes.string.isRequired,
  tabIndex: PropTypes.number,
  autoComplete: PropTypes.string,
};
